import { render, staticRenderFns } from "./RassegnaStampa.vue?vue&type=template&id=e2e897ca"
import script from "./RassegnaStampa.vue?vue&type=script&lang=js"
export * from "./RassegnaStampa.vue?vue&type=script&lang=js"
import style0 from "./RassegnaStampa.vue?vue&type=style&index=0&id=e2e897ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports